/**
 * AuditShell — sub-tab nav for the three read-only audit viewers.
 */

import { NavLink, Outlet } from 'react-router';

export function AuditShell(): JSX.Element {
  return (
    <>
      <h1>Audit</h1>
      <p className="page-intro">
        Read-only mirrors of the destructive-action and notification audit
        logs. Every grid is exportable to CSV.
      </p>

      <nav className="subnav" aria-label="Audit sub-pages" data-tour="audit-subnav">
        <NavLink to="purge-history">Purge history</NavLink>
        <NavLink to="test-mode-activity">Test Mode activity</NavLink>
        <NavLink to="notifications-history">Notifications history</NavLink>
      </nav>

      <Outlet />
    </>
  );
}
